import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Scanner from "../ScannerHtml5/Scanner";
import axios from "axios";
import config from "../../config/config";
import { toastError, toastSuccess } from "../../common/Toast";

const ScanToCart = () => {
    const navigate = useNavigate();
  const custData = useParams();
  console.log(custData, "custData");
  const [customerDetail, setCustomerDetail] = useState({
    Id: custData?.custId || 0,
    RoleTierID: custData?.roleId || 0,
  });
  const [startScannerCamera, setStartScannerCamera] = useState(true);

    const callbackScannerBulkCartData = (data) => {
        console.log(data, "FilteredBulkItems");
        const filteredList = data.map((el) => ({
        // UnitPrice: el.UnitPrice,
        ItemID: el.ID,
        VariationID: el.variationId,
        inputQty: el.inputQuantity,
        }));

        console.log(filteredList, "FilteredBulkItems");

        const bulkVariationProductList = {};
        bulkVariationProductList.bilkCartProductList = filteredList;

        let FilteredBulkItems = JSON.stringify(bulkVariationProductList);
        console.log(FilteredBulkItems, "FilteredBulkItems");
        // return;
            axios
            .post(
                `${config.ecommBackendBaseUrl}/products/bulkitemaddtocart`,
                {
                bulkdata: FilteredBulkItems,
                CustomerID: customerDetail?.Id > 0 ? customerDetail?.Id : 0,
                },
                {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    "Access-Control-Allow-Origin": "*",
                },
                }
            )
            .then((res) => {
                if (res.data.ResponseCode === "SUCCESS") {
                    toastSuccess("Items added to cart successfully");
                    window.open(`${config.ecommWebsiteUrl}/account/shopping-cart`, "_self");
                } else if (
                    res.data.ResponseCode === "ERROR" &&
                    res.data.ResponseData[0].ID === -1
                ) {
                    toastError("Item Already In Cart!");
                // setCheckMessage(res.data.ResponseMessage);
                } else if (
                res.data.ResponseCode === "ERROR" &&
                res.data.ResponseData[0].ID === -2
                ) {
                toastError("Error occurred while adding items to cart");
                // setCheckMessage(res.data.ResponseMessage);
                }
            })
            .catch((error) => {
                console.log("error occurred", error);
            });
    };

  return (
    <div className="pl-2 pr-2">
      {startScannerCamera && (
        <Scanner
          customerData={customerDetail}
          callbackBulkCartData={callbackScannerBulkCartData}
          setStartScannerCamera={setStartScannerCamera}
        />
      )}
    </div>
  );
};

export default ScanToCart;
